import React from "react";
import { Stack } from "@mui/material";
import { MENUS } from "../../../../../utils/ui.constants";
import SidebarItemIcon from "./SidebarItemIcon";
import { useLocation } from "react-router-dom";

function SidebarSmall() {
  const location = useLocation();

  return (
    <Stack sx={{ width: "100%", px: 2 }}>
      {MENUS.map((menu, i) => {
        const items = menu.items || [];
        return (
          <React.Fragment key={i}>
            {items.map((item, j) => {
              let active = item.path === "/" && location.pathname === "/";
              if (item.path && item.path !== "/") {
                active = location.pathname.includes(item.path);
              }
              return (
                <SidebarItemIcon
                  key={j}
                  text={item.text}
                  Icon={item.Icon}
                  href={item.path}
                  active={active}
                />
              );
            })}
          </React.Fragment>
        );
      })}
    </Stack>
  );
}

export default SidebarSmall;
